<template>
    <div class="home">
        <div class=" schedule animate__animated" :class="animated" v-if="workItemArr.length">
            <div class="cardTit">
                <span class="logoIcon"><img src="../assets/img/updateImg/logoIcon.svg" alt=""></span>
                <span class="teamName">{{workItem?workItem.teamName:''}}</span>
            </div>
            <div class="cardBg">
                <p class="theme">{{workItem?workItem.title:''}}</p>
                <p class="date">
                    <span>第{{ workItem?workItem.weekIndex:''}}周</span>
                    <span>{{ workItem?workItem.date:''}}</span>
                    <span>{{ workItem?workItem.start:''}} - {{ workItem?workItem.end:''}}</span>
                </p>
                <em><img src="../assets/img/updateImg/LINE.svg" alt=""></em>
                <div class="coaching">
                    <p class="bottom">
                        <span class="headImg" v-if="workItem.coaching" v-for="i in workItem.coaching"><img :src="i.avatar" alt=""></span>
                        <span class="ellipsis" v-if="workItem.coaching && workItem.coaching.length>6"><img
                                src="../assets/img/updateImg/ellipsis.svg" alt=""></span>
                    </p>
                </div>
            </div>
        </div>
        <div v-else class="cardBg schedule" style="line-height: 21vw">暂无数据</div>
        <p class="numberBg"><img src="../assets/img/numBg.svg" alt=""></p>
        <WebRTCFaceDetector :faceShowType="faceShowType"></WebRTCFaceDetector>
    </div>
</template>

<script>
    import $ from "jquery"
    import WebRTCFaceDetector from "../components/WebRTCFaceDetector";
    import photoCard from "../components/photoCard";

    export default {
        name: 'about',
        props: {
            // msg: String
        },
        components: {
            WebRTCFaceDetector,
            photoCard
        },
        computed: {
            lookCommandFn() {
                return this.$store.state.paramsCommand;
            }
        },
        watch: {
            lookCommandFn: {
                handler(value, old) {
                    let wake = this.$aiJson.wake;//唤醒人脸识别
                    let flag = 0;
                    for (let i = 0; i < wake.length; i++) {
                        if (eval('/' + wake[i] + '/gi').test(value)) {//唤醒人脸识别
                            if (!this.faceShowType) {
                                //判断当前是否已经是识别状态
                                this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                                this.faceShowType = true;
                            }
                            flag = 1;
                            return;
                        } else {
                            this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息--没听清
                            flag = 0
                        }
                    }
                },
                deep: true
            },
        },
        data() {
            return {
                workItemArr: [],//日程--总数据
                workItem: {},//日程
                animated: '',
                time: null,//时间定时器
                faceShowType: false,//人脸识别是否显示
                timeRes: null,//一小时请求一次首页工作项
            }
        },
        methods: {
            info() {
                this.$server.getAllWorkitem()
                    .then((res) => {
                        this.workItemArr = res.data ? res.data : [];
                        // this.workItem=res.data;
                        let randomNum = Math.floor(Math.random() * (this.workItemArr.length));
                        this.workItem = this.workItemArr[randomNum]
                        this.animatedFn(this.workItemArr)
                    })
            },
            animatedFn(dataList) {
                clearInterval(this.time);
                this.time = setInterval(() => {
                    this.animated = 'animate__fadeOutDown';
                    let setTimeoutTime = null;
                    setTimeoutTime = setTimeout(() => {
                        let randomNum = Math.floor(Math.random() * (dataList.length));
                        this.workItem = dataList[randomNum]
                        this.animated = 'animate__fadeInDown';
                        clearInterval(setTimeoutTime)
                    }, 1500)
                }, 8000)
            },
            //获取语音文件json
            speakJson() {
                //获取语音文件json
                this.$server.json()
                    .then((res) => {
                        this.$aiJson = res;
                        // console.log(this.$aiJson);
                    })
            },
            //重新加载
            againFn() {
                // alert(window.location.href);
                $.ajax({
                    url: window.location.href,
                    async: false,
                    cache: false,
                    ifModified: true,
                    beforeSend: (xmlHttp) => {
                        xmlHttp.setRequestHeader("If-Modified-Since", "0");
                        xmlHttp.setRequestHeader("Cache-Control", "no-cache");
                    },
                    success: (response) => {
                        // console.log('再次请求啦啦啦啦啦啦啦啦啦');
                        //操作
                        this.info();
                        this.$parent.closeAi();
                        this.$parent.info();
                        this.speakJson();
                    },
                });
            }
        },
        mounted() {
            this.info();
            this.speakJson();
            //一小时请求一次工作项 3600 * 1000 和 语音json
            this.timeRes = setInterval(() => {
                this.againFn();
            }, 3600000)
            // }, 10000)
        },
        beforeDestroy() {
            clearInterval(this.time);
            clearTimeout(this.timeRes)
        }
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

    .numberBg {
        opacity: .7;
        text-align: right;
        /*margin-top: 3vw;*/

        img {
            width: 92%;
            height: 21vw;
        }
    }

    .schedule {
        margin-top: 12%;
        color: #fff;
        font-size: 36px;
        width: 80%;
        margin-left: 10%;
        font-family: PingFangMedium;
        .cardTit {
            position: relative;
            .logoIcon {
                width: 3vw;
                height: 4vw;
                position: absolute;
                left: 1.5vw;
                top: 1.5vw;
                img{
                    width: 100%;
                }
            }
        }

        .cardBg {
            height: 24vw;
        }

        .theme {
            padding-top: 3vw;
            color: rgba(255, 255, 255, .8);
            padding-bottom: 2vw;
        }

        .date {
            color: var(--primary-color);
            margin-bottom: 1.5vw;

            span {
                margin-right: 80px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .coaching {
            position: relative;
            width: 80%;
            margin-left: 10%;
        }

        .bottom {
            margin-top: 1vw;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            //text-overflow: ellipsis;

            .headImg {
                background-color: rgba(12, 12, 13, 0.45);
                display: inline-block;
                width: 5vw;
                height: 5vw;
                border-radius: 100%;
                margin-right: 2.5vw;
                overflow: hidden;
                img{
                    width: 100%;
                }

                &:last-child {
                    margin-right: 0;
                }
            }

            .ellipsis {
                position: absolute;
                right: -1vw;
                top: 1.5vw;
            }
        }
    }
</style>
